import { render, staticRenderFns } from "./DashboardActivityStreamItem.vue?vue&type=template&id=69bbe56a&scoped=true"
import script from "./DashboardActivityStreamItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardActivityStreamItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardActivityStreamItem.vue?vue&type=style&index=0&id=69bbe56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bbe56a",
  null
  
)

export default component.exports